import { getClient } from '../lib/apiClient';
import {
  FETCHING_COMMON_APP_CONFIG,
  RECEIVE_COMMON_APP_CONFIG,
} from '../reducers/commonApp';

export function getCommonAppConfig(options) {
  const {
    incentive,
    offerId,
    includeDisabled,
  } = options;

  return async (dispatch, getState) => {
    dispatch({ type: FETCHING_COMMON_APP_CONFIG, options });
    const config = await getClient(process.env.NEXT_PUBLIC_API_DOMAIN, getState).get('/api/v2/org_applications/getConsumerApp', {
      params: {
        ...(incentive ? { offerId: incentive.offerId } : { offerId }),
        includeDisabled,
      },
    });
    dispatch({
      type: RECEIVE_COMMON_APP_CONFIG,
      config: config.data,
    });
  };
}
